import { IPolygonData } from "@/entities";
import { ILocation } from "@/entities/user/address";
import { IDraftOrderRepository } from "@/repositories/draftOrder";
import { IPolygonRepository } from "@/repositories/polygon";
import { IPolygonService } from ".";

export class PolygonService implements IPolygonService {
    constructor(private repository: IPolygonRepository) {}

    async getDeliveryCost(
        location: ILocation,
        apikey: string
    ): Promise<IPolygonData[]> {
        return await this.repository.getDeliveryCost(location, apikey);
    }
}
